import { AppAreaConfig } from '@/funnels/@types'

// DEV-35932: a separate landing area, using the existing glp-app quiz and paywall flow.
const appAreaConfig: AppAreaConfig = {
	appArea: 'glp-app-v2',
	options: {
		userTags: ['glp'],
		medicationFromLanding: true,
	},
	landing: {
		ids: ['glp-app-v2-universal'],
		overrides: [
			{ ids: ['glp-app-v2-tirzepatide'], matcher: { utm_term: /a1/i }, medication: 'tirzepatide' },
			{ ids: ['glp-app-v2-semaglutide'], matcher: { utm_term: /b1/i }, medication: 'semaglutide' },
		],
		route: {
			path: '/app-v2',
			name: 'glp-app-v2-funnel',
		},
	},
	funnel: {
		id: 'ob-kova-glp-1-app-ds',
		route: {
			path: '/app-v2/ob/:page(.*)?',
			name: 'glp-app-v2',
		},
		slug: 'glp-app',
		locale: ['en'],
	},
	paywall: {
		routeName: 'plan-glp-app-v2',
	},
}

export default appAreaConfig
